import { api } from "../../../app/api";
import { Options } from "../../../common/types/requestOptions";
import { OrderQueueOption } from "./types";

export enum OrderQueueType {
  DEFAULT = "default",
  CITY = "city",
  EC = "eezyCompany",
  TEAM_SPECIFIC = "teamSpecific",
}

export interface OrderQueue {
  id: string;
  name: string;
  members: {
    id: string;
    firstName: string;
    lastName: string;
    email: string;
  }[];
  cities?: string[];
  contracts: {
    contractId: string;
    name: string;
  }[];
  eezyCompany?: {
    id: string;
    name: string;
  };
  type: OrderQueueType;
}

export interface OrderQueueEvent {
  id: string;
  version: number;
  name: string;
  payload: any;
}

export interface PostOrderQueue {
  name: string;
  cities?: string[];
  experts?: string[];
}

export interface PostEezyCompanyOrderQueue {
  name: string;
  eezyCompanyId: string;
  cities: string[];
  experts: string[];
}

export interface EditOrderQueue {
  orderQueueId: string;
  name?: string;
  experts?: string[];
  cities?: string[];
}

export const listOrderQueues = ({ requestId }: Options = {}) => {
  return api.get<OrderQueueOption[]>("/projections/qry/orderQueues", {
    requestId,
    auth: true,
  });
};

export const listOrderQueueById = (id: string, { requestId }: Options = {}) => {
  return api.get<OrderQueue>("/projections/qry/orderQueueById", {
    requestId,
    auth: true,
    queryParams: {
      id,
    },
  });
};

export const listCities = ({ requestId }: Options = {}) => {
  return api.get<string[]>("/projections/qry/cities", {
    requestId,
    auth: true,
  });
};

export const addOrderQueue = (
  orderQueue: PostOrderQueue,
  { requestId }: Options = {},
) => {
  return api.post<OrderQueueEvent[]>("/order/cmd/createOrderQueue", {
    requestId,
    auth: true,
    body: {
      ...orderQueue,
    },
  });
};

export const addEezyCompanyOrderQueue = (
  orderQueue: PostEezyCompanyOrderQueue,
  { requestId }: Options = {},
) => {
  return api.post<OrderQueueEvent[]>("/order/cmd/createEezyCompanyOrderQueue", {
    requestId,
    auth: true,
    body: {
      ...orderQueue,
    },
  });
};

export const postEditOrderQueue = (
  orderQueue: EditOrderQueue,
  { requestId }: Options = {},
) => {
  return api.post<OrderQueueEvent[]>("/order/cmd/changeOrderQueue", {
    requestId,
    auth: true,
    body: {
      ...orderQueue,
    },
  });
};

export const deleteOrderQueue = (
  orderQueueId: string,
  { requestId }: Options = {},
) => {
  return api.post<OrderQueueEvent[]>("/order/cmd/removeOrderQueue", {
    requestId,
    auth: true,
    body: {
      orderQueueId,
    },
  });
};
